import Vue from 'vue';
import { MessageBox } from 'element-ui';
import {
    GET_WORKER_ORDER_DETAIL_REQUEST,
    GET_WORKER_ORDER_DETAIL_SUCCESS,
    GET_WORKER_ORDER_DETAIL_FAILURE,
    UPDATE_WORKER_ORDER_DETAIL_PARAMS,
    UPDATE_WORKER_ORDER_DETAIL_REMAINPAYTIME,
    // UPDATE_WORKER_ORDER_DETAIL_SERVER_INFO,
    UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS
} from '../mutationTypes';

const operateHeader = [
    {label: '操作账号', prop: 'count_name', 'min-width': '100'},
    {label: '姓名', prop: 'name', 'min-width': '100'},
    {label: '角色', prop: 'role', 'min-width': '100'},
    {label: '操作', prop: 'detail', 'min-width': '100'},
    {label: '操作时间', prop: 'time', 'min-width': '100'}
];

const state = {
    isNotData: {
        type: '',
        msg: ''
    },
    loading: false,
    reqParams: {
        orderId: '', // 订单id
        orderSn: '', // 施工单
        businessType: '', // 业务类型id
    },
    orderDetail: {
        orderInfo: {},
        carInfo: {},
        associatedOrder: {},    // 关联订单信息
        serverInfo: [],         // 服务信息
        goodsInfo: [],          // 商品信息
        settlementInfo: {},     // 结算信息
        buyInfo: [],            // 购买信息
        operate: [],            // 操作记录
    },
    operateHeader,
};

const mutations = {
    [GET_WORKER_ORDER_DETAIL_REQUEST](state) {
        state.loading = true;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_WORKER_ORDER_DETAIL_SUCCESS](state, res) {
        state.loading = false;
        state.orderDetail = res;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_WORKER_ORDER_DETAIL_FAILURE](state, res) {
        state.loading = false;
        if (res.errorType) {
            state.isNotData.type = true;
            state.isNotData.msg = res.errmsg;
        } else {
            state.isNotData.type = false;
            state.isNotData.msg = '';
        }
        // reset orderDetail
        state.orderDetail = {
            orderInfo: {},
            carInfo: {},
            associatedOrder: {},    // 关联订单信息
            serverInfo: [],         // 服务信息
            goodsInfo: [],          // 商品信息
            settlementInfo: {},     // 结算信息
            buyInfo: [],            // 购买信息
            operate: []
        };
    },
    [UPDATE_WORKER_ORDER_DETAIL_PARAMS](state, params) {
        const { orderId, orderNo, businessType } = params;
        if (orderId || orderId === '') state.reqParams.orderId = orderId;
        if (orderNo || orderNo === '') state.reqParams.orderNo = orderNo;
        if (businessType || businessType === '') state.reqParams.businessType = businessType;
    },
    [UPDATE_WORKER_ORDER_DETAIL_REMAINPAYTIME](state) {
        state.orderDetail.orderInfo.remainPayTime -= 1;
    },
    // 更新接车服务信息
    [UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS](state, res) {
        console.log('UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS', res);
        // state.orderDetail.serverInfo = res;
    },
};

export const actions = {
    async getWorkerOrderDetail({ commit }) {
        commit(GET_WORKER_ORDER_DETAIL_REQUEST);
        const res = await Vue.$ajax.get('worderOrderInfo', state.reqParams);
        if (!res.errorType) {
            commit(GET_WORKER_ORDER_DETAIL_SUCCESS, res);
        } else {
            commit(GET_WORKER_ORDER_DETAIL_FAILURE, res);
        }
    },
    resolveWorkerOrderDetailParams({ commit }) {
        const params = state.reqParams;
        commit(UPDATE_WORKER_ORDER_DETAIL_PARAMS, params);
    },
    updateRemainPayTime({ commit }) {
        commit(UPDATE_WORKER_ORDER_DETAIL_REMAINPAYTIME);
    },
    async updateWorkerOrderDetailServerInfo({ dispatch, commit }, params) {
        const res = await Vue.$ajax.post('selectWorker', params);
        console.log(params);
        console.log('res', res);
        if (!res.errorType) {
            commit(UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS, res);
            dispatch('getWorkerOrderDetail');
        } else {
            MessageBox.alert(res.errmsg || '未知错误', '操作失败！', {
                confirmButtonText: '知道了'
            });
        }
        // _.forEach(state.chosen, (item, index) => {
        //     const temp = list[index].masterWorkerIds;
        //     if (item.serverId === list[index].serverId &&
        //         item.masterWorkerIds.length !== temp.length) {
        //         // 统一修改, 一个服务ID(不管核销 | 普通服务), 都用同样的服务师傅
        //         state.chosen[index].masterWorkerIds = JSON.parse(JSON.stringify(temp));
        //     }
        // });
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/workerOrderDetail.js